import moment from "moment";
import CountryList from "@/Lib/CountryList";

export default () => {
    function getFbClientId() {
        let result = /_fbp=(fb\.1\.\d+\.\d+)/.exec(window.document.cookie);
        if (!(result && result[1])) {
            return null;
        }
        return result[1];
    }

    // Send Facebook Pixel ViewContent event
    function sendFacebookPixelViewContentEvent(campaign, module = '') {
        let data = {
            content_category: campaign,
        };

        fbq('track', 'ViewContent', data);

        logMarketingToolsEvent('Facebook Pixel', 'ViewContent', data, module);
    }

    // Send Facebook Pixel InitiateCheckout event
    function sendFacebookPixelInitiateCheckoutEvent(form, formData, summary, module = '') {
        if (form.participant_address1 == '' && form.participant_city == '') {
            form.participant_country = ''
        }

        if (!form.exclude_tax) {
            form.tax_country = ''
        }

        let icno    = form.tax_ic_no,
            gender  = '',
            dob     = '',
            country = '',
            state   = '';

        if (icno) {
            gender = icno.split('').pop() % 2 == 0 ? 'f' : 'm';

            const year  = icno.substr(0, 2);
            const month = icno.substr(2, 2);
            const day   = icno.substr(4, 4);

            const dateraw = year + '-' + month + '-' + day;
            dob           = moment(dateraw, "YY-MM-DD").format("YYYYMMDD");
        }

        let city = '';

        if (form.participant_city || form.tax_city) {
            city = form.participant_city
                ? form.participant_city.toLowerCase()
                : form.tax_city.toLowerCase();
        }

        country = form.participant_country
            ? (Object.keys(CountryList).find(key => CountryList[key] === form.participant_country) || null)
            : (Object.keys(CountryList).find(key => CountryList[key] === form.tax_country) || null);

        state = form.participant_state
            ? form.participant_state.toLowerCase()
            : (form.tax_state ? form.tax_state.toLowerCase() : '');

        let contents = Object.values(summary).flat()
            .filter((item) => item.count > 0)
            .map(function (item, index, Array) {
                return {
                    id: item.id,
                    quantity: item.count,
                    content_name: item.name,
                    code: item.code,
                    value: item.amount,
                    content_category: item.campaign,
                }
            });

        let content_ids = Object.values(summary).flat()
            .filter((item) => item.count > 0)
            .map(function (item, index, Array) {
                return item.id
            });

        let content_category = [...new Set(Object.values(summary).flat()
            .filter((item) => item.count > 0)
            .map(function (item, index, Array) {
                return item.campaign
            }))].join(', ');

        let data = {
            content_category: content_category,
            content_type: 'product',
            content_ids: content_ids,
            contents: contents,
            currency: formData.currency,
            value: form.order_amount,
            num_items: contents.length,

            // Advanced matching data
            em: form.participant_email,
            ph: form.participant_tel_no.replace(/[^0-9\.]+/g, ''),
            fn: form.participant_name.toLowerCase().replace(/\s/g, ''),
            db: dob,
            ge: gender,
            ct: city.replace(/\s/g, ''),
            st: state,
            zp: form.participant_postcode || form.tax_postcode,
            country: country ? country.toLowerCase() : null,
            external_id: form.participant_email,
        };

        fbq('track', 'InitiateCheckout', data);

        logMarketingToolsEvent('Facebook Pixel', 'InitiateCheckout', data, module);
    }

    // Send Facebook Pixel AddToCart event
    function sendFacebookPixelAddToCartEvent(selectedPackage, formData, module = '') {
        let data = {
            content_category: selectedPackage.campaign,
            content_name: selectedPackage.name,
            content_type: 'product',
            content_ids: [selectedPackage.id],
            currency: formData.currency,
            value: selectedPackage.amount
        };

        fbq('track', 'AddToCart', data);

        logMarketingToolsEvent('Facebook Pixel', 'AddToCart', data, module);
    }

    // Send Google Ads begin_checkout event
    function sendGoogleAdsBeginCheckoutEvent(form, formData, summary, module = '') {
        let items = Object.values(summary).flat()
            .filter((item) => item.count > 0)
            .map(function (item) {
                return {
                    item_id: item.id,
                    item_name: item.name,
                    item_category: item.campaign,
                    currency: formData.currency,
                    price: item.amount,
                    quantity: item.count,
                };
            }),

            data = {
                'send_to': formData.google_ads_tracking.begin_checkout_conversion_label,
                'value': form.order_amount,
                'currency': formData.currency,
                'items': items
            };

        gtag('event', 'conversion', data);

        logMarketingToolsEvent('Google Ads', 'begin_checkout', data, module);
    }

    // Send Google Ads begin_checkout event
    function sendGoogleAdsAddToCartEvent(formData, module = '') {
        let data = {
            'send_to': formData.google_ads_tracking.add_to_cart_conversion_label,
            'value': selectedPackage.amount,
            'currency': formData.currency,
            'items': [{
                'item_id': selectedPackage.id,
                'item_name': selectedPackage.name,
                'item_category': 'package',
                'currency': formData.currency,
                'price': selectedPackage.amount,
                'quantity': selectedPackage.count,
            }]
        };

        gtag('event', 'conversion', data);

        logMarketingToolsEvent('Google Ads', 'add_to_cart', data, module);
    }

    function logMarketingToolsEvent(tracker, event,  data, module = ''){
        let _token = $('meta[name="csrf-token"]').attr('content'),
            bayarcash_token = $(this).parents('.verify-token-action').prev('textarea').val();

        $.ajax({
            url: '/tools/marketing-tool-api-logs',
            type: "POST",
            data: {
                _token: _token,
                tracker: tracker,
                event: event,
                data: data,
                module: module,
            },
            beforeSend: function (xhr) {},
            success: (response) => {
                //
            },
            error: (jqXHR) => {
                if (jqXHR.status === 422) {
                    let errorMsg = jqXHR.responseJSON.errors.bayarcash_token[0];
                    console.log(errorMsg);
                } else {
                    let errorMsg = jqXHR.responseJSON.message;
                    console.log(errorMsg);
                }
            }
        });
    }

    return {
        getFbClientId,
        sendFacebookPixelViewContentEvent,
        sendFacebookPixelInitiateCheckoutEvent,
        sendGoogleAdsBeginCheckoutEvent,
        sendFacebookPixelAddToCartEvent,
        sendGoogleAdsAddToCartEvent
    }
}
